<template>
  <section class="console-section">
    <div class="container">
      <div class="console-container">
        <img
          :src="require('@/assets/image/console-section/ps5.png')"
          alt="ps5"
          class="ps5">
        <img
          :src="require('@/assets/image/console-section/xbox.png')"
          alt="xbox"
          class="xbox">
      </div>
      <div class="about">
        <div class="about__heading">
          <span>№2</span> Игровой <br>NextGen
        </div>
        <div class="about__text">
          Игровая индустрия вновь порадовала новинками!
          Игровые гиганты выпустили приставки нового
          поколения — PlayStation 5 и Xbox Series X. Игроков
          ждут новые ощущения игровой реальности и гейминг
          в 4К, а еще геймпад, который передает эффект
          соприкосновения с предметами в игре. В следующем
          году будет на одно развлечение больше
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';

export default {
  name: 'v-console-section',
  mounted() {
    const timelineConsole = gsap.timeline({
      scrollTrigger: {
        trigger: '.console-section',
        start: '-=40%',
        end: 'bottom',
        scrub: 1,
        onUpdate: (self) => {
          console.log('progress9:', self.progress);
          document.body.style.background = '#F4F4F4';
        },
      },
    });
    timelineConsole.addLabel('start')
      .to('.ps5', {
        scale: 0.2,
        y: '-40%',
        x: '0%',
        duration: 0.5,
      })
      .to('.xbox', {
        x: '18%',
        y: '-12%',
        scale: 0.5,
        opacity: 1,
        duration: 0.5,
      })
      .to('.ps5', {
        duration: 0.5,
        x: '-15%',
      }, '-=0.5')
      .to('.console-section .about', {
        y: '0%',
        opacity: 1,
        duration: 0.5,
      })
      .to('.console-section .about', {
        y: '0%',
        opacity: 1,
        duration: 2,
      });
  },
};
</script>

<style lang="scss">
.console-section {
  position: relative;
  min-height: 1100px;
  padding-top: 40px;

  .container {
    min-height: unset;
    overflow: hidden;
    position: sticky;
    top: 20px;
    padding: 0;
  }

  .about{
    opacity: 0;
    padding: 20px 15px 0;
  }

  .about__text{
    line-height: 1.4;
  }
}

.console-container{
  max-width: 100%;
  height: 310px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.ps5{
  position: absolute;
  top: 0;
  z-index: 10;
  transform: translate(2%, 29%) scale(1.7);
}

.xbox{
  transform: translate(50%, -12%) scale(0.5);
  opacity: 0;
  position: absolute;
}
</style>
